// extracted by mini-css-extract-plugin
var _1 = "Project_addButton__8ZAw8";
var _2 = "Project_addButtonIcon__+XY8r";
var _3 = "Project_board__Pwv7m";
var _4 = "Project_boardProgress__GEnnE";
var _5 = "Project_boardProgressBar__27zUu";
var _6 = "Project_boardTitle__JJtDs";
var _7 = "Project_boardWrapper__UoK9V";
var _8 = "Project_boardsWrapper__gqvRY";
var _9 = "Project_boardsWrapperEmpty__bgHZ8";
var _a = "Project_header__n3CNs";
var _b = "Project_headerButton__oKANk";
var _c = "Project_headerButtonGroup__cMhiK";
var _d = "Project_headerDetails__1Dhu4";
var _e = "Project_headerText__Z+ggc";
var _f = "Project_info__wA3Be";
var _10 = "Project_notification__w4Sek";
var _11 = "Project_title__kdDy-";
var _12 = "Project_wrapper__XCZxv";
export { _1 as "addButton", _2 as "addButtonIcon", _3 as "board", _4 as "boardProgress", _5 as "boardProgressBar", _6 as "boardTitle", _7 as "boardWrapper", _8 as "boardsWrapper", _9 as "boardsWrapperEmpty", _a as "header", _b as "headerButton", _c as "headerButtonGroup", _d as "headerDetails", _e as "headerText", _f as "info", _10 as "notification", _11 as "title", _12 as "wrapper" }
